import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ArrowIcon from "../../icons/arrow-down.js";
import "../dropdown-input/styles.css";
import Text from "../typography/text.js";
import RequiredIcon from "../../icons/required-icon.js";
import Button from "../button/button.js";
import { colors } from "../../theme/colors.js";
import ReactDOM from "react-dom";

const DropdownComponent = ({
  options = [],
  value = null,
  setValue,
  placeholder = "",
  isDisabled = false,
  label = "",
  isRequired = false,
  parentFunc,
  type,
  parentClassname,
  onChange,
  isSearchable = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  const [menuPos, setMenuPos] = useState({ left: 0, top: 0, width: 0 });

  const handleSelect = (option, e) => {
    console.log(option);
    if (onChange) {
      onChange?.(option);
    } else {
      setValue(option);
    }
    setIsOpen(false);
    setSearchTerm("");
    if (type === "ExcelExport") {
      parentFunc(option.value);
    }
  };

  const toggleDropdown = () => {
    if (!isDisabled) {
      if (isOpen) {
        setSearchTerm("");
      }
      setIsOpen((prev) => !prev);
    }
  };

  const handleTriggerKeyDown = (event) => {
    if (isDisabled) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleDropdown();
    } else if (event.key === "Escape") {
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  const filteredOptions = useMemo(() => {
    if (!isSearchable || !searchTerm.trim()) {
      return options;
    }

    const normalizedSearchTerm = searchTerm.trim().toLowerCase();
    return options.filter((option) =>
      String(option?.label ?? "")
        .toLowerCase()
        .includes(normalizedSearchTerm),
    );
  }, [isSearchable, options, searchTerm]);

  useLayoutEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setMenuPos({
        left: rect.left,
        top: rect.bottom + 4,
        width: rect.width,
      });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedTrigger = dropdownRef.current?.contains(event.target);
      const clickedMenu = menuRef.current?.contains(event.target);

      if (!clickedTrigger && !clickedMenu) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`text-input-container ${parentClassname}`}
      // style={{ position: "relative" }}
      ref={dropdownRef}
    >
      <div className={isRequired ? "text-input-title" : ""}>
        <Text variant="tinyText">{label}</Text>
        {isRequired && <RequiredIcon />}
      </div>

      <div
        className={
          isDisabled
            ? "text-input-box-container disabled-field"
            : "text-input-box-container"
        }
        onClick={toggleDropdown}
        onKeyDown={handleTriggerKeyDown}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
        aria-disabled={isDisabled}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label={label || placeholder}
      >
        {value?.label ? (
          <div
            className="text-input-field"
            style={isDisabled ? { color: colors["lightText"] } : {}}
          >
            {value?.label}
          </div>
        ) : (
          <div className="text-input-field placeholder">{placeholder}</div>
        )}
        <ArrowIcon className="icon-container" />
      </div>

      {/* {isOpen && (
        <div className="dropdown-option-container">
          {options.map((opt) => (
            <Button
              variant="table"
              subVariant="primary-hover"
              style={{
                width: "100%",
                justifyContent: "flex-start",
              }}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </Button>
          ))}
        </div>
      )} */}
      {isOpen &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            className="dropdown-option-portal"
            role="listbox"
            style={{
              position: "fixed",
              left: menuPos.left,
              top: menuPos.top,
              width: menuPos.width,
            }}
          >
            {isSearchable && (
              <div className="dropdown-search-container">
                <input
                  aria-label={`${label || placeholder} search`}
                  autoFocus
                  className="dropdown-search-input"
                  placeholder="Search..."
                  type="text"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Escape") {
                      setIsOpen(false);
                      setSearchTerm("");
                    }
                  }}
                />
              </div>
            )}
            {filteredOptions.map((opt) => (
              <Button
                key={opt.value ?? opt.label}
                variant="table"
                subVariant="primary-hover"
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                }}
                // onClick={(e) => handleSelect(opt, e)}
                onMouseDown={(e) => handleSelect(opt, e)}
              >
                {opt.label}
              </Button>
            ))}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default DropdownComponent;
